import React, { useEffect, useState } from "react";
import { ChartContainer } from "./style";
import { PieChart } from "@mui/x-charts/PieChart";
import { IconButton, Typography } from "@mui/material";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { ArrowForwardIosRounded, Circle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const PieChartProjects = ({ data }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  // uso useIntl() perchè piechart si aspetta una label di tipo string e non un componente react come <FormattedMessage />
  //STATE
  const [dataForChart, setDataForChart] = useState([]);

  //EFFECTS
  useEffect(() => {
    if (data?.paginated_results?.length > 0) {
      const remappedData = [
        {
          id: 1,
          value: data?.counters?.total_new_projects,
          label: intl.formatMessage({ id: "dashboard.review.project.new" }),
          color: "var(--info)",
        },
        {
          id: 2,
          value: data?.counters?.total_in_progress_projects,
          label: intl.formatMessage({
            id: "dashboard.review.project.inProgress",
          }),
          color: "var(--progress)",
        },
        {
          id: 3,
          value: data?.counters?.total_pending_projects,
          label: intl.formatMessage({ id: "dashboard.review.project.pending" }),
          color: "var(--pending)",
        },
        {
          id: 4,
          value: data?.counters?.total_failed_projects,
          label: intl.formatMessage({ id: "dashboard.review.project.failed" }),
          color: "var(--error)",
        },
        {
          id: 5,
          value: data?.counters?.total_refunded_projects,
          label: intl.formatMessage({
            id: "dashboard.review.project.refunded",
          }),
          color: "var(--refunded)",
        },
        {
          id: 6,
          value: data?.counters?.total_completed_projects,
          label: intl.formatMessage({
            id: "dashboard.review.project.completed",
          }),
          color: "var(--success)",
        },
      ];
      setDataForChart(remappedData);
    }
  }, [data, intl]);

  //HANDLERS
  const handleGoToProjects = () => {
    navigate(userDashboardRoute.projects);
  };

  return (
    <ColumnContainer minGap style={{ width: "100%" }}>
      <ChartContainer>
        <ColumnContainer minGap>
          <RowContainer align="center">
            <Typography variant="h6" color="var(--main-color)">
              <FormattedMessage id="dashboard.review.projects" />
            </Typography>
            <IconButton>
              <ArrowForwardIosRounded onClick={() => handleGoToProjects()} />
            </IconButton>
          </RowContainer>

          <RowContainer>
            {dataForChart.length === 0 ? (
              <ColumnContainer>
                <Typography variant="p" color="var(--text-secondary)">
                  <FormattedMessage id="table.noData" />
                </Typography>
              </ColumnContainer>
            ) : (
              <PieChart
                series={[
                  {
                    data: dataForChart,
                    innerRadius: 10,
                    outerRadius: 100,
                    paddingAngle: 1,
                    cornerRadius: 3,
                    cx: 150,
                    cy: 150,
                  },
                ]}
                slotProps={{
                  legend: { hidden: true },
                }}
                height={300}
                width={"100%"}
              />
            )}
          </RowContainer>

          <ColumnContainer style={{ gap: "5px" }}></ColumnContainer>
        </ColumnContainer>
      </ChartContainer>
    </ColumnContainer>
  );
};

export default PieChartProjects;
